var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleHealthbarEssentia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 291,
    height: 101.678,
    viewBox: "0 0 291 101.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_27",
    "data-name": "Ret\\xE2ngulo 27",
    width: 290.708,
    height: 72.062,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c79e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0d0a2",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1827",
    "data-name": "Grupo 1827",
    transform: "translate(-432 -4431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(432 4460.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_737",
    "data-name": "Caminho 737",
    d: "M31.212,0V14.569H12.695V0H6.451V35.594h6.243V20.065H31.212V35.594h6.244V0Z",
    transform: "translate(-5.131 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_738",
    "data-name": "Caminho 738",
    d: "M194.962,0V35.594h24.387V30.1H201.205V20.226h17.77v-5.5h-17.77V5.5h18.144V0Z",
    transform: "translate(-155.06 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    "data-name": "Caminho 739",
    d: "M345.031,5.283,351.7,23.267H338.361ZM341.136,0,327.154,35.594h6.831l2.615-6.831h16.863l2.615,6.831h6.831L348.927,0Z",
    transform: "translate(-260.198)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_740",
    "data-name": "Caminho 740",
    d: "M520.88,0V35.594h21.933V30.1H527.123V0Z",
    transform: "translate(-414.275 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_741",
    "data-name": "Caminho 741",
    d: "M618.4,0V5.5h10.78v30.1h6.244V5.5H646.2V0Z",
    transform: "translate(-491.834 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_742",
    "data-name": "Caminho 742",
    d: "M804.815,0V14.569H786.3V0h-6.244V35.594H786.3V20.065h18.517V35.594h6.244V0Z",
    transform: "translate(-620.405 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_743",
    "data-name": "Caminho 743",
    d: "M971.693,0h14.622c5.924,0,9.819,3.469,9.819,9.072a8.1,8.1,0,0,1-6.244,8.165c3.789.587,6.937,4.589,6.937,8.752,0,5.923-3.842,9.606-10.246,9.606H971.693Zm14.248,15.956c4.589,0,6.991-2.882,6.991-6.564,0-3.629-2.4-6.617-6.991-6.617H974.735V15.957Zm.213,16.863c4.7,0,7.471-2.722,7.471-7.044,0-3.629-2.508-7.044-7.471-7.044h-11.42V32.82Z",
    transform: "translate(-772.823 -0.001)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_744",
    "data-name": "Caminho 744",
    d: "M1139.989,26.842h-18.944l-3.575,8.752h-3.416L1128.623,0h3.789l14.568,35.594h-3.415Zm-17.984-2.775h17.023L1130.49,2.988Z",
    transform: "translate(-886.048)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M1311.366,20.866h-7.844V35.594h-3.042V0h13.288c6.137,0,10.833,3.9,10.833,10.406,0,6.457-4.589,10.033-9.872,10.246l10.3,14.942h-3.682ZM1313.5,2.775h-9.979V18.091h9.979c4.7,0,7.9-3.2,7.9-7.684s-3.2-7.631-7.9-7.631",
    transform: "translate(-1034.319)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_746",
    "data-name": "Caminho 746",
    d: "M0,241.417H14.946v2.936H3.336v6.506H14.713v2.936H3.336v6.939h11.61v2.936H0Z",
    transform: "translate(0 -192.008)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_747",
    "data-name": "Caminho 747",
    d: "M119.43,256.668a9.383,9.383,0,0,0,7.006,3.136c3.6,0,4.871-1.835,4.871-3.436,0-2.335-2.535-3-5.371-3.737-3.57-.934-7.707-1.968-7.707-6.506,0-3.67,3.236-6.339,7.873-6.339a10.908,10.908,0,0,1,8.107,3.1l-1.935,2.469a8.68,8.68,0,0,0-6.439-2.6c-2.469,0-4.17,1.268-4.17,3.136,0,2,2.4,2.636,5.171,3.336,3.636.967,7.873,2.1,7.873,6.839,0,3.47-2.4,6.706-8.407,6.706a11.387,11.387,0,0,1-8.774-3.536Z",
    transform: "translate(-93.474 -190.711)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    "data-name": "Caminho 748",
    d: "M246.413,256.668a9.383,9.383,0,0,0,7.006,3.136c3.6,0,4.871-1.835,4.871-3.436,0-2.335-2.535-3-5.371-3.737-3.57-.934-7.707-1.968-7.707-6.506,0-3.67,3.236-6.339,7.873-6.339a10.908,10.908,0,0,1,8.107,3.1l-1.935,2.469a8.68,8.68,0,0,0-6.439-2.6c-2.469,0-4.17,1.268-4.17,3.136,0,2,2.4,2.636,5.171,3.336,3.636.967,7.873,2.1,7.873,6.839,0,3.47-2.4,6.706-8.407,6.706a11.387,11.387,0,0,1-8.774-3.536Z",
    transform: "translate(-194.469 -190.711)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    "data-name": "Caminho 749",
    d: "M378.177,241.417h14.946v2.936h-11.61v6.506H392.89v2.936H381.513v6.939h11.61v2.936H378.177Z",
    transform: "translate(-300.778 -192.008)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_750",
    "data-name": "Caminho 750",
    d: "M505.725,246.588V263.67h-3.336V241.417h3.436L517.935,258.1V241.417h3.336V263.67h-3.236Z",
    transform: "translate(-399.568 -192.008)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_751",
    "data-name": "Caminho 751",
    d: "M649.317,244.353h-6.906v-2.936h17.115v2.936h-6.873V263.67h-3.336Z",
    transform: "translate(-510.933 -192.008)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_26",
    "data-name": "Ret\\xE2ngulo 26",
    width: 3.336,
    height: 22.253,
    transform: "translate(158.367 49.409)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_752",
    "data-name": "Caminho 752",
    d: "M850.324,259.067H839.414l-1.8,4.6h-3.67l8.841-22.252h4.17L855.8,263.67h-3.67Zm-9.942-2.969h8.974l-4.5-11.777Z",
    transform: "translate(-663.266 -192.009)",
    fill: "#161615"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_33",
    "data-name": "Ret\\xE2ngulo 33",
    width: 291,
    height: 5,
    transform: "translate(432 4431)",
    opacity: 0.717,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleHealthbarEssentia);
export default __webpack_public_path__ + "static/media/title-healthbar-essentia.3ec49450773109cf16a24ba5099b6b9a.svg";
export { ForwardRef as ReactComponent };